import type { CompanyCostCategory } from './api/companyCostsApi';

// Categorical dataviz palette (dataviz skill, `references/palette.md` default
// order) — one hue per company-cost category, assigned in the fixed slot
// order the skill validates (never cycled). Single home for the category
// identity color, shared by:
//   - FixedCosts.tsx's "Koszty stałe miesiąca" hero breakdown + entries/
//     templates tables
//   - Profitability.tsx's "Przegląd" overview tab (ProfitabilityOverview.tsx)
//     fixed-costs mini bar-list for the selected month
// Lifted out of FixedCosts.tsx (2026-08) when the overview tab needed the
// same identity colors — do not fork a second copy for a new surface.
export const CATEGORY_COLORS: Record<CompanyCostCategory, string> = {
  LEASING: '#2a78d6',
  OFFICE: '#eb6834',
  UTILITIES: '#1baf7a',
  SALARIES: '#eda100',
  INSURANCE: '#e87ba4',
  ACCOUNTING: '#008300',
  SUBSCRIPTIONS: '#4a3aa7',
  OTHER: '#e34948',
};
